<template>
    <div>
        <div v-if="!vehicle">Loading...</div>
        <div v-if="vehicle.company_id === $store.state.user.companies[0].id || canViewCreateDealPage()">Unauthorized Page</div>
        <div v-else>
            <div class="d-flex justify-content-between pb-3">
                <h3 class="card-title font-16 mt-0">
                    {{ vehicle.formattedFullVehicleName }}
                </h3>
            </div>
            <div class="row">
                <div class="col-lg-3 col-12 px-2">
                    <div class="pb-lg-5">
                        <div class="py-2">
                            <label>Mileage: </label>
                            <span>{{ vehicle.mileage | local_number }}</span>
                        </div>
                        <div class="py-2">
                            <label>Body: </label>
                            <span>{{ data_get(vehicle, 'body.name') }}</span>
                        </div>
                        <div class="py-2">
                            <label>Condition: </label>
                            <span>{{ data_get(vehicle, 'condition.name') }}</span>
                        </div>
                        <div class="py-2">
                            <label>Color: </label>
                            <span>{{ data_get(vehicle, 'color.name') }}</span>
                        </div>
                        <div class="py-2">
                            <label>Dealership Info: </label>
                            <span>
<!--                         TODO: Dealership Info would be the dealer’s name and location-->
                            </span>
                        </div>
                        <div class="py-2">
                            <label>Foundri ID: </label>
                            <span>FND-{{ vehicle.id }}</span>
                        </div>
                        <div class="py-2">
                            <label>VIN: </label>
                            <span>{{ vehicle.vin }}</span>
                        </div>
                        <div class="py-2">
                            <label>Distance: </label>
                            <span></span>
                        </div>
                        <div class="py-2">
                            <label>Status: </label>
                            <span>
                                <i
                                    :class="[vehicleStatusClass]"
                                    class="mdi mdi-checkbox-blank-circle"
                                   />
                                {{ vehicleStatusLabel }}
                            </span>
                        </div>
                        <div class="mb-2" v-if="vehicle.company.is_wholesale">
                            <span class="badge badge-secondary">Wholesale</span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-5 col-12 images-container px-0 pr-sm-5">
                    <image-swiper :images="imageUrls"/>
                </div>
                <div class="col-lg-4 col-12 p-0">
                    <div class="text-right deal-buttons-container mt-3 m-sm-0">
                        <div class="mb-2 d-flex justify-content-end">
                            <label class="mb-0 mr-2 align-self-center">{{ vehicle.price | currency }} </label>
                            <span
                                :title="!can_enquire ? buttonTitleByStatus : ''"
                                v-b-tooltip.hover>
                                <button
                                    v-if="userCanEnquireAndHold"
                                    class="btn btn-primary waves-effect waves-light"
                                    type="button"
                                    :disabled="!can_enquire || isEnquiryDisabled"
                                    @click="enquire"
                                    >
                                    <i class="mdi mdi-ear-hearing"/>
                                    Enquire
                                </button>
                            </span>
                        </div>
                        <template v-if="vehicle.status !== VehicleStatus.sold.value">
                            <div class="mb-2">
                                <span
                                    :title="buttonTitleByStatus"
                                    v-b-tooltip.hover>
                                    <b-button
                                        v-if="userCanEnquireAndHold"
                                        type="primary"
                                        :disabled="!can_hold || isHoldDisabled"
                                        @click="hold"
                                        >
                                        <i class="mdi mdi-shield"/>
                                        Hold
                                    </b-button>
                                </span>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 px-0 px-sm-2">
                    <div class="form-group">
                        <label class="col-form-label">Deal Conditions:</label>
                        <div>
                            <textarea :rows="4"
                                      class="form-control"
                                      title="deal conditions"
                                      readonly
                                      type="text"
                                      v-model="vehicle.deal_conditions"/>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 px-0 px-sm-2">
                    <div class="form-group">
                        <label class="col-form-label">Physical Transfer Info:</label>
                        <div>
                            <textarea :rows="4"
                                      class="form-control"
                                      title="physical transfer info"
                                      readonly
                                      type="text"
                                      v-model="vehicle.physical_transfer_info"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-right">
                <button @click="backToResults()"
                        class="btn btn-primary waves-effect waves-light"
                        type="button">
                    <i class="mdi mdi-car"/>
                    Back to Results
                </button>
            </div>
        </div>
        <div aria-hidden="true"
             aria-labelledby="mySmallModalLabel"
             class="modal fade bs-example-modal-center"
             data-backdrop="static"
             data-keyboard="false"
             ref="dealModal"
             role="dialog"
             tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content" v-if="modal_type">
                    <div class="modal-header">
                        <h5 class="modal-title mt-0">{{ modal_type.title }}</h5>
                        <button aria-hidden="true" class="close" data-dismiss="modal" type="button">×</button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group row">
                            <label class="col-sm-5 col-lg-4 col-form-label">FND-{{ vehicle.id }}</label>
                            <div class="col-sm-7 col-lg-8 align-self-center">
                                <div>
                                    {{ vehicle.formattedFullVehicleName }}
                                </div>
                                <div>
                                    <span class="badge badge-info m-1" v-if="vehicle.mileage">
                                        <span>Mileage: </span>
                                        <span>{{ vehicle.mileage | local_number }}</span>
                                    </span>
                                    <span class="badge badge-info m-1" v-if="data_get(vehicle, 'condition.name')">
                                        <span>Condition: </span>
                                        <span>{{ data_get(vehicle, 'condition.name') }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-5 col-lg-4 col-form-label">Vin:</label>
                            <div class="col-sm-7 col-lg-8 align-self-center">
                                <span>{{ vehicle.vin }}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-5 col-lg-4 col-form-label">Dealer:</label>
                            <div class="col-sm-7 col-lg-8 align-self-center">
                                <span>{{ dealer }}</span>
                            </div>
                        </div>
                        <div v-if="modal_type === MODAL_TYPES.hold">
                            <div class="form-group">
                                <label class="col-form-label">Comments:</label>
                                <div>
                                    <textarea :class="{ 'parsley-error' : holdForm.errors.has('comments') }"
                                              :rows="4"
                                              class="form-control"
                                              type="text"
                                              v-model="holdForm.comments"/>
                                    <ul :class="{'filled' : holdForm.errors.has('comments')}"
                                        class="parsley-errors-list">
                                        <li class="parsley-required">{{
                                            holdForm.errors.get('comments') }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-12 text-center">
                                    <button :disabled="holdForm.busy"
                                            @click="submit"
                                            class="btn btn-primary w-md waves-effect waves-light text-uppercase"
                                            type="submit">Hold
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div v-else-if="modal_type === MODAL_TYPES.enquire">
                            <div class="form-group">
                                <label class="col-form-label">Message:</label>
                                <div>
                                    <textarea :class="{ 'parsley-error' : enquiryForm.errors.has('message') }"
                                              :rows="4"
                                              class="form-control"
                                              type="text"
                                              v-model="enquiryForm.message"/>
                                    <ul :class="{'filled' : enquiryForm.errors.has('message')}"
                                        class="parsley-errors-list">
                                        <li class="parsley-required">
                                            {{ enquiryForm.errors.get('message') }}
                                        </li>
                                    </ul>
                                </div>
                                <div class="py-2">
                                    <i class="mdi mdi-alert-circle" />
                                    Foundri recommends you ask for CARFAX and Damage Reports
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-12 text-center">
                                    <button :disabled="enquiryForm.busy"
                                            @click="submit"
                                            class="btn btn-primary w-md waves-effect waves-light text-uppercase"
                                            type="submit">Enquire
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div aria-hidden="true"
             aria-labelledby="mySmallModalLabel"
             class="modal fade bs-example-modal-center"
             data-backdrop="static"
             data-keyboard="false"
             ref="infoEnquiryModal"
             role="dialog"
             tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title mt-0">Enquiry</h5>
                        <button aria-hidden="true" class="close" data-dismiss="modal" type="button">×</button>
                    </div>
                    <div class="modal-body">
                        <div class="font-16">
                            <div class="el-icon-info"/>
                            Your dealership has already enquired about this vehicle. See message <a class="link-class" @click="handleEnquiryInfoRedirect">here</a>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <b-button @click="closeInfoEnquiryModal">Close</b-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ImageSwiper from "@/components/custom/ImageSwiper";
import Routes from "@/constants/routes";
import Deal from "@/models/deal";
import { DealStatus } from "@/constants/deal-statuses";
import VehicleStatus from "@/constants/vehicle-statuses";
import vehicle_mixin from "@/mixins/vehicle";
import Roles from "@/constants/roles";

const MODAL_TYPES = {
    hold: {
        title: 'Hold Request'
    },
    enquire: {
            title: 'Enquiry'
        }
    };

    export default {
        mixins: [vehicle_mixin],
        props: {
            vehicle: {
                type: Object,
                default() {
                    return {};
                }
            }
        },
        components: {
            ImageSwiper
        },
        data() {
            return {
                MODAL_TYPES,
                DealStatus,
                VehicleStatus,
                Routes,
                modal_type: null,
                holdForm: new Form(
                    {
                        vehicle_id: null,
                        comments: null,
                        status: DealStatus.holdRequest.value,
                    },
                    {
                        vehicle_id: 'required',
                        comments: 'required|string',
                        status: 'required|integer',
                    }
                ),
                enquiryForm: new Form(
                    {
                        vehicle_id: null,
                        message: null,
                        status: DealStatus.enquiry.value,
                    },
                    {
                        vehicle_id: 'required',
                        message: 'required|string',
                        status: 'required|integer',
                    }
                ),
                can_enquire: false,
                can_hold: false,
                deal_status: null,
            }
        },
        mounted() {
            $(this.$refs.dealModal).on('hidden.bs.modal', () => {
                this.holdForm.comments = null;
                this.enquiryForm.message = null;
            });
            this.holdForm.vehicle_id = this.vehicle.id;
            this.enquiryForm.vehicle_id = this.vehicle.id;
            if (parseInt(this.$route.query.open)) {
                this.offer();
            }
        },
        created() {
            this.initDealButtonPermissions();
            this.initVehicleDealStatus();
        },
        computed: {
            dealer() {
                return this.vehicle.company.name
            },
            imageUrls() {
                if (!this.vehicle) {
                    return [];
                }
                return _.map(this.vehicle.images, image => image.url)
            },
            user() {
                return this.$store.state.user;
            },
            buttonTitleByStatus() {
                let title = null;
                switch (this.vehicle.status) {
                    case DealStatus.onHold.value:
                        title = 'Vehicle is on hold.';
                        break;
                    case DealStatus.sold.value:
                        title = 'Vehicle was sold.';
                        break;
                    case DealStatus.completed.value:
                        title = 'Vehicle is not available.';
                        break;
                }
                return title;
            },
            isEnquiryDisabled() {
                return !_.includes([
                    DealStatus.enquiry.value,
                    DealStatus.holdRequest.value,
                    DealStatus.onHold.value
                ], this.deal_status);
            },
            isHoldDisabled() {
                return _.includes([
                    DealStatus.onHold.value,
                    DealStatus.sold.value,
                    DealStatus.completed.value
                ], this.deal_status);
            },
            userCanEnquireAndHold() {
                return !this.hasRole([Roles.sales_person]);
            },
            hasCurrentEnquiryFromMyDealership() {
                return this.vehicle.deals.some(deal => deal.buyer?.companies[0].id === this.$store.state.user?.companies[0].id);
            },
        },
        methods: {
            backToResults() {
                if (this.$route.query.back) {
                    return this.$router.push(this.$route.query.back);
                }
                return this.$router.push({
                    name: Routes.vehicle
                });
            },
            hold() {
                this.modal_type = MODAL_TYPES.hold;
                this.showDealModal();
            },
            enquire() {
                if (!this.hasCurrentEnquiryFromMyDealership) {
                    this.modal_type = MODAL_TYPES.enquire;
                    this.showDealModal();
                } else {
                    this.$nextTick(() => {
                        $(this.$refs.infoEnquiryModal).modal('show');
                    })
                }
            },
            showDealModal() {
                this.$nextTick(() => {
                    $(this.$refs.dealModal).modal('show');
                })
            },
            closeInfoEnquiryModal() {
                this.$nextTick(() => {
                    $(this.$refs.infoEnquiryModal).modal('hide');
                })
            },
            initDealButtonPermissions() {
                this.can_hold = this.vehicle.status === DealStatus.enquiry.value
                    || this.vehicle.status === DealStatus.holdRequest.value;
                axios.get(`/web-api/vehicle/${this.vehicle.id}/can-enquire`)
                    .then((response) => {
                        this.can_enquire = response.data.can_enquire;
                    })
            },
            submit() {
                switch (this.modal_type) {
                    case MODAL_TYPES.hold:
                        this.holdForm.validate()
                            .then(() => {
                                let hold_request = new Deal(this.holdForm);
                                hold_request.save()
                                    .then(() => {
                                        this.$notify.success({
                                            message: 'Hold request has been sent.'
                                        });
                                        $(this.$refs.dealModal).modal('hide');
                                        this.$emit('updated');
                                    })
                            });
                        break;
                    case MODAL_TYPES.enquire:
                        this.enquiryForm.validate()
                            .then(() => {
                                let enquiry = new Deal(this.enquiryForm);
                                enquiry.save()
                                    .then(() => {
                                        this.$notify.success({
                                            message: 'Enquiry has been sent.'
                                        });
                                        $(this.$refs.dealModal).modal('hide');
                                        this.$emit('updated');
                                    })
                            });
                        break;
                }
            },
            initVehicleDealStatus() {
                axios.get(`/web-api/deal/${this.vehicle.id}/status`)
                    .then((response) => {
                        this.deal_status = response.data.status;
                    })
            },
            canViewCreateDealPage() {
                if (this.hasRole([Roles.sales_person])) {
                    const deal = this.vehicle.deals.find(deal => deal.buyer.companies[0].id === this.$store.state.user.companies[0].id);

                    if (deal) {
                        return deal.buyer_id !== this.$store.state.user.id;
                    }
                }

                return false;
            },
            handleEnquiryInfoRedirect() {
                const deal = this.vehicle.deals.find(deal => deal.buyer?.companies[0].id === this.$store.state.user.companies[0].id);
                this.closeInfoEnquiryModal();
                setTimeout(() => {
                    this.$router.push({
                        name: Routes.message,
                        params: {
                            deal_id: deal.id,
                            customer_id: deal.seller_id,
                        }
                    });
                }, 150);
            },
        }
    }
</script>

<style lang="scss" scoped>
    .images-container {
        min-height: 300px;
    }
    .deal-buttons-container {
        button {
            width: 100px;
        }
    }
    .link-class {
        color: #15A9F0;
        font-style: italic;
        cursor: pointer;
    }
</style>
